import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { useViewerRoles } from '@treams/treams-hooks';
import { Heading, Paragraph, tokens } from '@treams/treams-ui';

import EmployeesBulkButton from './EmployeesBulkButton';
import EmployeesContextProvider from './EmployeesContextProvider';
import EmployeesFilters from './EmployeesFilters';
import EmployeesList from './EmployeesList';

const Split = styled.div`
	display: flex;
	flex-direction: row;
	flex-grow: 1;
`;

const Main = styled.div`
	display: flex;
	flex-direction: column;
	flex: 0.7;
	flex-shrink: 1;
	overflow: hidden;
	overflow-x: scroll;
`;

const Sidebar = styled.div`
	background: ${tokens.surface.secondary};
	flex: 0.3;
	padding: ${tokens.padding.container}px;
	flex-shrink: 0;
`;

export function EmployeesContainerWithoutSidebar() {
	const { t } = useTranslation();
	const roles = useViewerRoles();
	const [selected, setSelected] = useState<{ id: string; firstName: string; lastName: string }[]>(
		[],
	);

	const columns = useMemo(():
		| ('firstName' | 'lastName' | 'activatedAt' | 'lastLoginAt')[]
		| undefined => {
		return roles.isAdministrator || roles.isWorkspaceSuperuser
			? undefined
			: ['firstName', 'lastName', 'activatedAt', 'lastLoginAt'];
	}, [roles]);

	return (
		<EmployeesContextProvider>
			<Split>
				<Main>
					<Flex
						p={`${tokens.padding.container}px`}
						alignItems="center"
						style={{ height: '70px' }}
						flexGrow={0}
						flexShrink={0}
					>
						<Box flexGrow={1} flexShrink={1}>
							<Heading>{t('common.organization.employeeList.title')}</Heading>
						</Box>
						{selected.length > 0 && (
							<Flex marginLeft={10} flexGrow={0} flexShrink={0} alignItems="center">
								<Paragraph mr={3}>
									{t('common.organization.employeeList.selectionCount', { count: selected.length })}
								</Paragraph>
								<EmployeesBulkButton selection={selected} />
							</Flex>
						)}
					</Flex>
					<EmployeesList columns={columns} selection={selected} onChange={setSelected} />
				</Main>
				<Sidebar>
					<EmployeesFilters />
				</Sidebar>
			</Split>
		</EmployeesContextProvider>
	);
}
